import checkGreenIconWieldy from "@assets/random/Check_green_icon.png";
import errorIconWieldy from "@assets/random/error-icon.png";
import infoIconWieldy from "@assets/random/info-icon.png";
import warningIconWieldy from "@assets/random/warning_icon.png";

import checkGreenIcon from "@assets/random/notify-white-icon.png";
import errorIcon from "@assets/random/notify-white-icon.png";
import loadingIcon from "@assets/random/loading-icon.png";
import infoIcon from "@assets/random/notify-green-icon.png";
import warningIcon from "@assets/random/notify-warning-icon.png";
import projectConfig from "@projectConfig";
import "./style.less";

const createNotificationMessage = (txt, icon, type, timeout = 3000, buttons) => {
   // CSS TOP - depends on mobile keyboard
   let visualViewportTop = 4;
   if (window?.visualViewport?.height) {
      visualViewportTop = window?.screen?.height - window?.visualViewport.height;
      if (visualViewportTop < 0) {
         visualViewportTop = 4;
      }
      if (visualViewportTop > 100) {
         visualViewportTop -= 100;
      }
   }

   const messageConfig = projectConfig.notificationMessage;
   const notificationMessageContainer = document.querySelector(".notification-message-container");
   if (notificationMessageContainer) {
      notificationMessageContainer.style.top = `${visualViewportTop}px`;
   }
   const notificationMessage = document.createElement("div");
   const notificationMessageContent = document.createElement("div");
   const notificationMessageIcon = document.createElement("img");
   const notificationMessageTxt = document.createElement("p");
   const notificationMessageX = document.createElement("button");

   notificationMessageTxt.textContent = txt;
   notificationMessageIcon.src = icon;
   notificationMessageIcon.className = `${
      type === "loading" ? "loading-spinner-icon" : "notify-icon"
   }`;
   notificationMessage.className = `notification-message message-type-${type}-${messageConfig.type}`;
   notificationMessageContent.className = `notification-message-content`;
   notificationMessageX.className = "close-notify";
   notificationMessageX.innerText = "x";
   notificationMessageX.addEventListener("click", () => {
      Message.destroy();
   });
   if (notificationMessageContainer && notificationMessage) {
      notificationMessageContent.appendChild(notificationMessageIcon);
      notificationMessageContent.appendChild(notificationMessageTxt);
      notificationMessage.appendChild(notificationMessageContent);
      if (buttons?.label) {
         const actionBtn = document.createElement("button");
         actionBtn.className = "notify-action-btn";
         actionBtn.textContent = buttons.label;
         actionBtn.addEventListener("click", () => {
            if (typeof buttons.onClick === "function") buttons.onClick();
            Message.destroy();
         });
         notificationMessage.appendChild(actionBtn);
      }
      if (type !== "loading" && messageConfig.type !== "wieldy" && !buttons?.label) {
         notificationMessage.appendChild(notificationMessageX);
      }
      notificationMessageContainer.appendChild(notificationMessage);
   }

   if (
      (type === "success" || type === "error" || type === "info" || type === "warning") &&
      notificationMessageContainer?.firstChild &&
      timeout > 0
   ) {
      setTimeout(() => {
         try {
            notificationMessageContainer.removeChild(notificationMessageContainer.firstChild);
         } catch (e) {
            console.log("Remove message alert error");
         }
      }, timeout);
   }
};

export class Message {
   static success = (txt, timeout, buttons) => {
      const viewType = projectConfig.notificationMessage.type;
      createNotificationMessage(
         txt,
         viewType === "wieldy" ? checkGreenIconWieldy : checkGreenIcon,
         "success",
         timeout,
         buttons,
      );
   };

   static error = (txt, timeout, buttons) => {
      const viewType = projectConfig.notificationMessage.type;
      createNotificationMessage(
         txt,
         viewType === "wieldy" ? errorIconWieldy : errorIcon,
         "error",
         timeout,
         buttons,
      );
   };

   static info = (txt, timeout, buttons) => {
      const viewType = projectConfig.notificationMessage.type;
      createNotificationMessage(
         txt,
         viewType === "wieldy" ? infoIconWieldy : infoIcon,
         "info",
         timeout,
         buttons,
      );
   };

   static warning = (txt, timeout, buttons) => {
      const viewType = projectConfig.notificationMessage.type;
      createNotificationMessage(
         txt,
         viewType === "wieldy" ? warningIconWieldy : warningIcon,
         "warning",
         timeout,
         buttons,
      );
   };

   static loading = (txt, timeout, buttons) => {
      createNotificationMessage(txt, loadingIcon, "loading", timeout, buttons);
   };
   static destroy = () => {
      const notificationMessageContainer = document.querySelector(
         ".notification-message-container",
      );
      if (notificationMessageContainer?.firstChild) {
         try {
            notificationMessageContainer.removeChild(notificationMessageContainer.firstChild);
         } catch (e) {
            console.log(e);
         }
      }
   };
}
